__turbopack_context__.v({
  "form": "page-module__vWlGAq__form",
  "formButtons": "page-module__vWlGAq__formButtons",
  "list": "page-module__vWlGAq__list",
});
